export default __webpack_public_path__ + "static/media/LandingPageBG.0881ad5a.jpg";